import React from 'react';
import PropTypes from 'prop-types';
import { DialogActions, DialogContent, Button } from '@material-ui/core';
import { withStyles, createStyles } from '@material-ui/core/styles';
import DialogHeader from 'components/DialogHeader';
import { Dialog } from 'components/v2';

const useStyle = ({
  palette: {
    common: { black },
  },
  spacing: { unit },
}) =>
  createStyles({
    submitLabel: {
      textTransform: 'uppercase',
    },
    dialogContent: {
      color: black,
      display: 'inline-block',
      fontSize: 16,
      fontWeight: 500,
      minHeight: 141,
      padding: 3 * unit,
      width: '100%',
    },
  });

class DialogConfirmation extends React.PureComponent {
  // eslint-disable-line react/no-deprecated
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      submitting: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { visible } = this.props;

    if (visible !== nextProps.visible) this.setState({ submitting: false });
  }

  handleSubmit() {
    const { onSubmit } = this.props;

    this.setState({ submitting: true });
    onSubmit();
  }

  render() {
    const {
      cancelLabel,
      headerIcon,
      label,
      children,
      onCancel,
      submitBackgroundColor,
      submitLabel,
      submitLabelStyle,
      submitStyle,
      submitDisabled,
      title,
      visible,
      classes,
    } = this.props;
    const { submitting } = this.state;

    return (
      <Dialog fullWidth onClose={onCancel} open={visible}>
        <DialogHeader leftIcon={headerIcon || ''} title={title || 'Confirmation'} onRequestClose={onCancel} />
        <DialogContent className={classes.dialogContent}>
          {children}
          <div
            dangerouslySetInnerHTML={{ __html: label || '' }} // eslint-disable-line react/no-danger
          />
        </DialogContent>
        <DialogActions>
          <Button data-lh-id="dialog-confirmation-cancel-button" onClick={onCancel} color="primary" variant="text">
            {cancelLabel || 'Cancel'}
          </Button>
          {/* TODO: Change to makeStyles when we have MUI V4 */}
          <Button
            disabled={submitting || submitDisabled}
            onClick={this.handleSubmit}
            color={!(submitBackgroundColor || submitStyle) ? 'primary' : 'secondary'}
            style={{ ...submitStyle, backgroundColor: submitBackgroundColor }}
            variant="contained"
            data-lh-id="dialog-confirmation-submit-button"
          >
            <span className={classes.submitLabel} style={submitLabelStyle}>
              {submitLabel || 'OK'}
            </span>
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

DialogConfirmation.propTypes = {
  cancelLabel: PropTypes.string,
  headerIcon: PropTypes.string,
  label: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitBackgroundColor: PropTypes.string,
  submitLabel: PropTypes.string,
  submitLabelStyle: PropTypes.object,
  submitStyle: PropTypes.object,
  submitDisabled: PropTypes.bool,
  title: PropTypes.string,
  visible: PropTypes.bool.isRequired,
};

export default withStyles(useStyle)(DialogConfirmation);
